module.exports = __webpack_public_path__ + "static/media/photo22.44f93741.jpg";